export default __webpack_public_path__ + "static/media/nfg-logo.78fb340d.svg";